module.exports = __webpack_public_path__ + "static/img/task_appraise_2.166c9adb.png";